import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ItemListRequest } from "../models/Items/ItemListRequest";
import { SortDirection } from "../models/Enum";
import { MULTI_SELECT_FIELD_NAMES, PRODUCT_TYPE_DROPDOWN_OPTIONS } from "../pages/Products/EditItem/Constants";

interface InactiveItemsState {
    itemListRequest: ItemListRequest;
};

const initialItemListRequest = {
    pageIndex: 1,
    pageSize: 10,
    sortBy: "updatedDate",
    sortDirection: SortDirection.DESC,
};

// const initialAttachmentListRequest = {
//   pageIndex: 1,
//   pageSize: 10,
//   sortBy: "prjCode",
//   sortDirection: SortDirection.DESC,
// };

const initialInactiveProductListRequest = {
  ...initialItemListRequest,
  [MULTI_SELECT_FIELD_NAMES.developmentType]: [PRODUCT_TYPE_DROPDOWN_OPTIONS[0].id],
  hideReleasedToInriver: true,
  hideArchivedDevelopment: true,
};

const initialState: InactiveItemsState = {
  itemListRequest: initialInactiveProductListRequest,
};

const inactiveItems = createSlice({
  name: 'inactiveItems',
  initialState,
  reducers: {
    updateInactiveItemListRequest(state, action: PayloadAction<ItemListRequest>) {
      state.itemListRequest = action.payload;
    },
  },
});

export const { updateInactiveItemListRequest } = inactiveItems.actions;

export default inactiveItems.reducer;
